import React from 'react';
import './construction.css';

const ConstructionPage = () => {
  return (
    <div className="construction-container">
      <div className="construction-content">
        {/* Construction Icon */}
        <div className="construction-icon">
          <div className="cone">
            <div className="cone-top"></div>
            <div className="cone-bottom"></div>
            <div className="cone-stripe"></div>
          </div>
        </div>

        {/* Main Heading */}
        <h1 className="construction-title">
          We're Building Something Amazing!
        </h1>

        {/* Subtitle */}
        <p className="construction-subtitle">
          Our page is currently under construction. We're working hard to bring you an amazing experience.
        </p>

        {/* Progress Bar */}
        <div className="progress-container">
          <div className="progress-bar">
            <div className="progress-fill"></div>
          </div>
          <span className="progress-text">85% Complete</span>
        </div>

        {/* Additional Message */}
        <div className="construction-message">
          <p>Thank you for your patience while we make improvements.</p>
          <p>We'll be back soon with exciting new features!</p>
        </div>

        {/* Animated Tools */}
        <div className="tools-container">
          <div className="tool hammer">🔨</div>
          <div className="tool wrench">🔧</div>
          <div className="tool gear">⚙️</div>
        </div>
      </div>
    </div>
  );
};

export default ConstructionPage;
